<script>

import { BarElement, CategoryScale, Chart as ChartJS, Legend, LineElement, LinearScale, PointElement, Title, Tooltip } from 'chart.js'
import { Line as ChartLine } from 'vue-chartjs'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement)
export default {
  name: 'DashboardDonationsChart',
  components: { ChartLine },
  props: {
    reportData: {
      type: Array,
      default: () => []
    },
    reportDataCompareWith: {
      type: Array,
      default: () => []
    },
    criteria: {
      type: Object,
      default: () => {
        return {
          timeframe_string: 'last_30_days'
        }
      }
    }
  },
  data() {
    return {
      ErrorMessage: null
    }
  },
  computed:{
    groupedByName () {
      return ['year_to_date', 'last_year', 'lifetime', 'last_3_months', 'last_6_months'].indexOf(this.criteria.timeframe_string) > -1 ? 'monthly' : 'daily'
    },
    chartData () {
      if (this.reportData) {
        let labels = []
        if (this.groupedByName === 'monthly') {
          labels = this.reportData.map(item => item.month)
        } else {
          labels = this.reportData.map(item => this.$filters.formatDateOnly(item.date))
        }
        console.log(this.reportData)
        return {
          labels: labels,
          datasets: [
            { label: this.$filters.formatString(this.groupedByName) + ' Donations Count', data: this.reportData.map(item => item.donations_count), backgroundColor: '#59b039', borderColor: '#32621f', yAxisID: 'count', },
            { label: this.$filters.formatString(this.groupedByName) + ' Donations Amount', data: this.reportData.map(item => item.donations_amount), backgroundColor: '#4b8be2', borderColor: '#2c5588', yAxisID: 'amount', }
          ]
        }
      } else {
        return {}
      }
    },
    chartOptions () {
      return {
        height: 24,
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          amount: {
            type: 'linear',
            position: 'left',
            title: {
              display: true,
              color: '#2c5588',
              text: 'Donation Amount ($)'
            },
            ticks: {
              color: '#2c5588',
              beginAtZero: true
            }
          },
          count: {
            type: 'linear',
            position: 'right',
            grid: {
              drawOnChartArea: false
            },
            title: {
              display: true,
              color: '#32621f',
              text: 'Number of Donations'
            },
            ticks: {
              beginAtZero: true,
              color: '#32621f',
              stepSize: 1
            }
          }
        }
      }
    },
  }
}
</script>

<template>
  <chart-line v-if="reportData" :options="chartOptions" :data="chartData" />
</template>

<style scoped>

</style>
